/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespBuyerAssuranceBox_user$ref = any;
export type PdpRespBuyerAssuranceBox_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": PdpRespBuyerAssuranceBox_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespBuyerAssuranceBox_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '5442a9fcd76f6f65e644d9f0d377c9f9';
export default node;
